'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
import { Card } from '../../components/Card';
import { createTransition, dontForwardProps } from '../../util';
import { colors } from '../../abstracts';
import { toggleParentStyles } from '../ToggleCore';
const StyledCard = styled(Card).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-15bzeug-0"
})(["display:inline-flex;align-items:flex-start;box-sizing:border-box;text-align:left;line-height:1.3;-moz-osx-font-smoothing:grayscale;", " ", ";"], () => createTransition({
  properties: ['box-shadow', 'background-color']
}), toggleParentStyles);
const Wrapper = /*#__PURE__*/React.forwardRef((props, fRef) => /*#__PURE__*/React.createElement(StyledCard, _extends({
  ref: fRef,
  element: "label",
  type: "selection",
  selected: props.checked || props.focused
}, props)));
const InternalWrapper = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-15bzeug-1"
})(["display:flex;z-index:1;width:100%;justify-content:center;padding:0.1rem 0 0 0;", ";", " ", ""], createTransition({
  properties: ['color']
}), ({
  isDisabled
}) => isDisabled && `
      cursor: not-allowed;
      color: ${colors.disabledText};
`, ({
  disableSvgColorOverride,
  isDisabled
}) => !disableSvgColorOverride && `
    svg path {
      fill: none;
      stroke: ${isDisabled && colors.disabledText};
    }
`);
export const SelectionCardStrip = {
  Wrapper,
  InternalWrapper
};